import { useContext, useState } from "react";
import {
  Container,
  makeStyles,
  Typography,
  Button,
  Box,
  CircularProgress,
} from "@material-ui/core";
import FileUpload from "../../components/file-upload";
import { AuthContext } from "../../context";
import { Loader, Toast } from "../../components";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { laboratoryServices } from "../../services";
import GetAppRoundedIcon from "@material-ui/icons/GetAppRounded";

export default function AssignToDoctorByFile() {
  const [toast, setToast] = useState({ open: false, message: "" });
  const [loading, setLoading] = useState(false);
  const classes = useStyles();
  const { authState } = useContext(AuthContext);
  const history = useHistory();
  const [isExampleDownloading, setIsExampleDownloading] = useState(false);

  const handleDownloadExample = async () => {
    try {
      setIsExampleDownloading(true);

      const { status, response } =
        await laboratoryServices.downloadExampleAssignProductsDoctorsByExcel({
          token: authState.token,
        });
      if (status === 200) {
        var blob = new Blob([response], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "assignProductsDoctorExample.xlsx";
        link.click();
        window.URL.revokeObjectURL(link.href);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsExampleDownloading(false);
    }
  };

  const onHandleUpload = async (data) => {
    const file = data[0].file;
    const formData = new FormData();
    formData.append("file", file);
    try {
      setLoading(true);

      const { status, response } =
        await laboratoryServices.assignProductsDoctorsByExcel({
          token: authState.token,
          data: formData,
        });
      if (status === 200) {
        setToast({
          open: true,
          message: "Asignacion exitosa",
        });
        return;
      }
      setToast({
        open: true,
        message: response.message,
      });
      return;
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <Container maxWidth="lg" component={"main"} className={classes.container}>
      {loading && <Loader loading={true} />}
      <Toast
        open={toast.open}
        message={toast.message}
        close={() => setToast({ open: false, message: "" })}
      />
      <Typography component={"h2"} variant="h6">
        Asignar muestras por archivo
      </Typography>
      <Box style={{ display: "flex", justifyContent: "end", marginBottom: 8 }}>
        <Button
          variant="outlined"
          size="small"
          startIcon={
            isExampleDownloading ? (
              <CircularProgress size={16} color="#333" />
            ) : (
              <GetAppRoundedIcon />
            )
          }
          onClick={handleDownloadExample}
          disabled={isExampleDownloading}
        >
          Descargar ejemplo
        </Button>
      </Box>
      <FileUpload
        hasExample={false}
        title="Asignar muestras"
        onHandleAction={onHandleUpload}
      />
    </Container>
  );
}

const useStyles = makeStyles((theme) => ({
  container: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    paddingTop: 12,
    "& button": {
      textTransform: "none !important",
    },
  },
}));
